module.exports = __webpack_public_path__ + "img/28.e86584f2.jpg";